/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Container, Row, ListGroup } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom";
import { questionColor } from "../../../utils/QuestionColor";
import {useGetSubcategoryQuestionData} from "../services"
import Loading from "../../../components/Loading/Loading";
const CompleteCategoryItemSection = () => {
    const navigate = useNavigate();
    const { checklist, category, section } = useParams();
    
    const { data, isLoading } = useGetSubcategoryQuestionData(checklist, category, section);
    if (isLoading)
        return (
            <div className="flex w-100 pt-5">
                <div className="loading-main">
                    <Loading />
                </div>
            </div>
        );
    return (
        <>
            <Container fluid>
                <Row className="w-full 2xl:max-w-[1536px] 2xl:m-auto">
                    <Col>
                        <div className='py-2 flex justify-between items-center'>
                            <div className='flex'>
                                <button className="unac-btn-primary-fade" onClick={() => navigate(-1)}>Back</button>
                            </div>
                            <div className='flex'>
                                <h6 className="fw-bold m-0"> {data?.title}</h6>
                            </div>
                            <div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <hr className="w-full 2xl:max-w-[1536px] 2xl:m-auto" />

            <Container>
                <Row className="md:justify-center">
                    <Col sm md={10} lg={9}>
                        <div className='mt-4'>ITEM OVERALL SCORE</div>
                        <div className='score-label'>{data?.avg}</div>
                        <div className='mb-3 mt-5'>ITEM BREAKDOWN</div>
                        {data?.questions?.length >= 1 && data?.questions?.map((i, index) => {                            
                            return (
                                <ListGroup key={index}>
                                    <ListGroup.Item className='cursor-pointer'>
                                        <div className="flex items-center justify-between my-2">
                                            <h6 className='m-0 fw-bold pe-3'>{i.title}</h6>
                                            <div className='flex' >
                                            <div className={`${i.answer_value === 0 ? "text-lg" : "text-2xl"} h-9 w-9 flex text-[white] basis-9 items-center justify-center capitalize rounded-md`} style={{ background: questionColor(i.answer_value) }} >{`${i.answer_value === 0 ? "N/A" : i.answer_value}`}</div>
                                            </div>
                                        </div>
                                    </ListGroup.Item>
                                </ListGroup>
                            )
                        })}

                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default CompleteCategoryItemSection